import api from 'marketplace-front-core/config/api'

export default ({ $axios, store }, inject) => {
  inject('api', api($axios, store))
}
